import { render, staticRenderFns } from "./dzMapChsPoint.vue?vue&type=template&id=6fed9412"
import script from "./dzMapChsPoint.vue?vue&type=script&lang=js"
export * from "./dzMapChsPoint.vue?vue&type=script&lang=js"
import style0 from "./dzMapChsPoint.vue?vue&type=style&index=0&id=6fed9412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports